import homeIcon from "~/assets/home.svg";
import Image from "~/components/atoms/Image";
import { cn } from "~/lib/utils";

export type Breadcrumb = {
    label: string;
    href?: string;
};

const BreadcrumbItem = ({
    breadcrumb: { label, href },
    isLast,
    truncateOnMobile,
}: {
    breadcrumb: Breadcrumb;
    isLast: boolean;
    truncateOnMobile: boolean;
}) => {
    const truncateClassName = "w-[140px] sm:w-fit truncate";
    return !isLast ? (
        <a className={truncateOnMobile ? truncateClassName : ""} href={href}>
            {label}
        </a>
    ) : (
        <div className="cursor-default pr-1 text-gray-80">{label}</div>
    );
};
export default function BreadcrumbsBar({ items = [] }: { items?: Breadcrumb[] }) {
    const home = (
        <a href="https://plus.imgacademy.com">
            <span className="group flex flex-row items-center gap-[5px]">
                <Image alt={"home"} src={homeIcon} className="size-[15px] min-w-[15px]" />
                <span className="hidden sm:block">
                    IMG Academy
                    {/* Override font for this plus sign since our fonts "+" won't bold correctly. */}
                    <span className="font-sans font-bold" style={{ fontFamily: "system-ui" }}>
                        +
                    </span>
                </span>
            </span>
        </a>
    );
    return (
        <div
            className="flex flex-row items-center gap-1 text-[15px] font-light leading-[21.75px] text-blue-80"
            data-testid="breadcrumbs-testid"
        >
            {home}
            {items.map((item, index) => {
                const last = index === items.length - 1;
                const truncateIndex = items.length >= 2 ? items.length - 2 : -1;
                const truncateOnMobile = index === truncateIndex;
                return (
                    <span
                        key={item.label}
                        className={cn(
                            "flex flex-row items-center gap-3",
                            truncateOnMobile ? "" : "hidden sm:flex",
                        )}
                    >
                        <span>/</span>
                        <BreadcrumbItem
                            breadcrumb={item}
                            isLast={last}
                            truncateOnMobile={truncateOnMobile}
                        />
                    </span>
                );
            })}
        </div>
    );
}
